import React from "react";
import { MiniBar, blowerStatusColor, TankLevel } from "./stpHelpers";

const StpAerationPanel = ({ d }) => {
  const { aeration } = d;
  const doOk  = aeration.doLevel >= 2.0 && aeration.doLevel <= 4.0;
  const doCol = aeration.doLevel < 2.0 ? "#ef4444" : aeration.doLevel > 4.0 ? "#f59e0b" : "#10b981";
  const maxDo = Math.max(...aeration.doHistory.map(x => x.do));

  return (
    <div className="stp-aeration-panel">

      {/* ── Main KPIs ── */}
      <div className="stp-aer-kpis">
        <div className="stp-aer-kpi-lg" style={{ borderTopColor: doCol }}>
          <div className="stp-aer-kpi-val" style={{ color: doCol }}>{aeration.doLevel} <span style={{ fontSize: 16, fontWeight: 500 }}>mg/L</span></div>
          <div className="stp-aer-kpi-lbl">Dissolved Oxygen (DO)</div>
          <div className="stp-aer-kpi-target">Target: {aeration.doTarget} mg/L · Optimal: 2.0–4.0 mg/L</div>
          {!doOk && <div className="stp-aer-warn">{aeration.doLevel < 2 ? "⚠ Below minimum — risk of poor nitrification" : "⚠ Above optimal — over-aeration"}</div>}
          <div style={{ marginTop: 10 }}>
            <MiniBar value={aeration.doLevel} max={6} color={doCol} height={10} />
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: "#9ca3af", marginTop: 3 }}>
              <span>0</span><span>2.0 min</span><span>4.0 opt</span><span>6.0 max</span>
            </div>
          </div>
        </div>

        {[
          { label: "MLSS",               value: `${aeration.mlss} mg/L`,           sub: "Optimal: 2500–4000",         color: aeration.mlss > 4000 ? "#f59e0b" : aeration.mlss < 2500 ? "#ef4444" : "#10b981" },
          { label: "Tank Level",          value: `${aeration.tankLevel}%`,           sub: "Aeration tank",              color: "#3b82f6" },
          { label: "O₂ Transfer Eff",     value: `${aeration.oxygenTransferEff}%`,   sub: "Standard: 20–30%",           color: "#8b5cf6" },
          { label: "Sludge Concentration",value: `${aeration.sludgeConcentration} g/L`, sub: "Mixed liquor",            color: "#f97316" },
        ].map(k => (
          <div key={k.label} className="stp-aer-kpi" style={{ borderTopColor: k.color }}>
            <div className="stp-ak-val" style={{ color: k.color }}>{k.value}</div>
            <div className="stp-ak-lbl">{k.label}</div>
            <div className="stp-ak-sub">{k.sub}</div>
          </div>
        ))}
      </div>

      {/* ── DO History ── */}
      <div className="stp-chart-card">
        <div className="stp-section-title">DO Level Trend — Last 12 Hours</div>
        <div className="stp-do-chart">
          {aeration.doHistory.map((pt, i) => {
            const col = pt.do < 2 ? "#ef4444" : pt.do > 4 ? "#f59e0b" : "#10b981";
            return (
              <div key={i} className="stp-do-col">
                <div className="stp-do-bar-wrap">
                  <div className="stp-do-bar" style={{ height: `${(pt.do / 5) * 100}%`, background: col }} />
                </div>
                <div className="stp-do-val" style={{ color: col }}>{pt.do}</div>
                <div className="stp-do-lbl">{pt.t.replace(":00","")}</div>
              </div>
            );
          })}
        </div>
        <div style={{ display: "flex", gap: 16, fontSize: 11, color: "#6b7280", marginTop: 6 }}>
          <span style={{ color: "#ef4444" }}>▬ Below min (2.0)</span>
          <span style={{ color: "#10b981" }}>▬ Optimal (2–4)</span>
          <span style={{ color: "#f59e0b" }}>▬ Over-aeration (&gt;4)</span>
        </div>
      </div>

      {/* ── Blowers ── */}
      <div className="stp-section-title">Blower Status</div>
      <div className="stp-blower-grid">
        {aeration.blowers.map(bl => {
          const st = blowerStatusColor(bl.status);
          return (
            <div key={bl.id} className="stp-blower-card" style={{ borderTopColor: st.color }}>
              <div className="stp-bl-header">
                <div className="stp-bl-id">{bl.id}</div>
                <span className="stp-badge" style={{ background: st.bg, color: st.color }}>{bl.status}</span>
              </div>
              <div className="stp-bl-name">{bl.name}</div>
              <div className="stp-bl-stats">
                <div className="stp-bl-stat"><div className="stp-bl-sv">{bl.rpm > 0 ? bl.rpm : "—"}</div><div className="stp-bl-sl">RPM</div></div>
                <div className="stp-bl-stat"><div className="stp-bl-sv">{bl.power > 0 ? `${bl.power} kW` : "—"}</div><div className="stp-bl-sl">Power</div></div>
                <div className="stp-bl-stat"><div className="stp-bl-sv">{bl.airFlow > 0 ? `${bl.airFlow} m³/h` : "—"}</div><div className="stp-bl-sl">Air Flow</div></div>
                <div className="stp-bl-stat"><div className="stp-bl-sv">{bl.runHours > 0 ? `${bl.runHours}h` : "—"}</div><div className="stp-bl-sl">Today</div></div>
              </div>
              {bl.efficiency && (
                <div style={{ marginTop: 8 }}>
                  <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 3 }}>Efficiency: {bl.efficiency}%</div>
                  <MiniBar value={bl.efficiency} max={100} color={bl.efficiency > 85 ? "#10b981" : "#f59e0b"} height={6} />
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="stp-ai-strip">
        🤖 AI: DO level has been below 2.0 mg/L for 3 hours — risk of incomplete nitrification. Recommend increasing BL-01 and BL-02 to 1550 RPM. Estimated recovery time: 45 minutes.
      </div>
    </div>
  );
};

export default StpAerationPanel;
